import React, { createContext, useContext, useReducer } from 'react';
import PropTypes from 'prop-types';

// https://medium.com/simply/state-management-with-react-hooks-and-context-api-at-10-lines-of-code-baf6be8302c
export const StateContext = createContext();
export const DispatchContext = createContext();
export const CombinedProvider = ({ reducer, initialState, children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};
export const useStateValue = (key) => {
  const combinedState = useContext(StateContext);
  return combinedState[key];
};
export const useDispatch = () => useContext(DispatchContext);

CombinedProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: PropTypes.shape({}).isRequired,
  reducer: PropTypes.func.isRequired,
};
